import React, { Component } from "react";

class FeelingProud extends Component {
  render() {
    return (
      <img
        src="adlynwebsite.png"   // ✅ path from public folder
        alt="Feeling Proud Graphic"
      
      />
    );
  }
}

export default FeelingProud;
